import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, object } from 'prop-types';
import StickyTableItem from '../../hoc/StickyTableItem';

class StatisticsGoalsTotal extends PureComponent {
  static propTypes = {
    config: array.isRequired,
    stats: object.isRequired,
  };

  render() {
    const { config, stats } = this.props;

    return (
      <tr>
        {config.map(({ id }, i) => {
          if (i === 0) {
            return (
              <StickyTableItem className='leftCol' key={id}>
                <FormattedMessage id="statistics.table.total" defaultMessage="Total" />
              </StickyTableItem>
            );
          } else {
            if (stats[id]) {
              return <td key={id}>{stats[id]}</td>;
            }
          }
        })}
      </tr>
    );
  }
}

export default StatisticsGoalsTotal;
